export default __webpack_public_path__ + "static/media/ESSS30BZIR45_1920x1080.274fa215.jpg";